<template>
<div>

  <div class="slider-container">
    <div v-if="sliderArrow" class="swiper-service-button-next" slot="button-next">
      <span></span>
    </div>
    <swiper ref="awesomeSwiperServices" :options="swiperOptionServices">
      <swiper-slide v-bind:key="index" v-for="(item, index) in services">
        <a
          :href="item.ServiceDetailsUrl"
          class="services-card-block"
          v-if="isHome"
          :target="item.LinkTarget"
        >
          <div class="services-card">
            <div class="services-card-content">
              <div class="services-card-icon">
                <img
                  class="services-card-icon-dynamic"
                  :src="item.ServiceIcon"
                  alt="image item"
                />
              </div>
              <p class="services-card-brief">{{ item.ServiceName }}</p>
            </div>
            <div class="view-details">
              <span>{{ item.SeeMoreBtnText }}</span>
              <i class="icon-next"></i>
            </div>
          </div>
        </a>
        <a
          :href="item.ServiceDetailsUrl"
          class="services-card-block"
          v-if="!isHome"
          target="_blank"
        >
          <div class="services-card">
            <div class="services-card-content">
              <div class="services-card-icon">
                <img
                  class="services-card-icon-static"
                  src="/Assets/Images/pdf.svg"
                  alt="pdf icon"
                />
              </div>
              <p class="services-card-brief">{{ item.ServiceName }}</p>
            </div>
            <div class="view-details">
              <span>{{ item.SeeMoreBtnText }}</span>
              <!-- <i class="icon-dنownload"></i> -->
            </div>
          </div>
        </a>
      </swiper-slide>
    </swiper>
    <div v-if="sliderArrow" class="swiper-service-button-prev" slot="button-prev">
      <span></span>
    </div>
  </div>
  <!-- <div class="view-all-wrapper" v-if="isHome">
      <a :href="viewAllUrl" class="view-all">{{ viewAll }}</a>
  </div> -->

</div>
  <!--<div class="container">
                <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                        <a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">Services</a>
                        <a class="nav-item nav-link" v-on:click="reinitSlider" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false">Products</a>
                    </div>
                </nav>
            </div>
            <div class="tab-content" id="nav-tabContent">
                <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div class="container">
                        <h2 class="generic-title">Services</h2>
                        <h3 class="generic-description">Our services meet a range of business challenges</h3>
                    </div>
                    <div class="slider-container">
                        <div class="swiper-service-button-next" slot="button-next">
                            <span></span>
                        </div>
                        <swiper ref="awesomeSwiperServices" :options="swiperOptionGeneric">
                            <swiper-slide v-bind:key="index" v-for="(item, index) in 6">
                                <a href="#">
                                    <div class="services-card">
                                        <div class="services-card-content">
                                            <i class="icon-document"></i>
                                            <p class="services-card-brief">Request for a register for controlled or semi controlled drugs custody</p>
                                        </div>
                                        <div class="view-details">
                                            <i class="icon-next"></i>
                                            <span>View Details</span>
                                        </div>
                                    </div>
                                </a>
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-service-button-prev" slot="button-prev">
                            <span></span>
                        </div>
                    </div>
                    <div class="view-all-wrapper">
                        <a class="view-all">View all</a>
                    </div>
                </div>
                <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <h2 class="generic-title">Products</h2>
                    <h3 class="generic-description">Our services meet a range of business challenges</h3>
                    <swiper ref="awesomeSwiperProducts" :options="swiperOptionGeneric">
                        <swiper-slide v-bind:key="index" v-for="(item, index) in 3">
                            <div class="services-card">
                                <i class="icon-document"></i>
                                <p class="services-card-brief">Request for a register for controlled or semi controlled drugs custody</p>
                                <a href="#" class="view-details">
                                    View Details
                                </a>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>-->
</template>

<script>
//import axios from 'axios';
//let baseUrl = document.location.origin;
//let apiUrl = baseUrl + "";
//let contactApiUrl;
//let listingThis;

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    SectionName: {
      type: String,
    },
    SectionTitle: {
      type: String,
    },
    isHome: {
      type: Boolean,
    },
    services: {
      type: Array,
    },
    viewAll: {
      type: String,
    },
    viewAllUrl: {
      type: String,
    }
  },
  data() {
    return {
      sliderArrow: true,
      swiperOptionServices: {
        navigation: {
          nextEl: ".swiper-service-button-next",
          prevEl: ".swiper-service-button-prev",
        },
        loop: false,
        spaceBetween: 15,
        allowTouchMove: true,
        centeredSlides: false,
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 10,
            allowTouchMove: true,
          },
          500: {
            slidesPerView: 1.5,
            spaceBetween: 10
          },
          0: {
            slidesPerView: 1.5,
            spaceBetween: 20
          },
        },
      },
    };
  },
  methods: {
    //reinitSlider: function () {
    //    setTimeout(() => {
    //        this.$refs.awesomeSwiperProducts.updateSwiper();
    //    }, 500);
    //    //if (window.innerWidth <= 1024) {
    //    //    setTimeout(() => {
    //    //        listing.$refs.mySwiperEvents.updateSwiper();
    //    //        document.getElementById("nav-profile").removeAttribute("style");
    //    //    }, 500);
    //    //} else {
    //    //    setTimeout(() => {
    //    //        listing.$refs.mySwiperEvents.updateSwiper();
    //    //        document.getElementById("pills-events").removeAttribute("style");
    //    //    }, 200);
    //    //}
    //},
    //updateSwiper() {
    //    this.swiper.update();
    //},
  },
  computed: {
    swiper() {
      return this.$refs.awesomeSwiperServices.$swiper;
    },
  },
  mounted() {
    document.querySelector(".generic-loader").style.display = "none";
    if(window.innerWidth >= 768) {
      if(this.services.length <= 3) {
        this.sliderArrow = false;
      } else {
        this.sliderArrow = true;
      }
    } else {
      this.sliderArrow = false;
    }
  },
  watch: {},
};
</script>
